





























































































import SpaInput from '@/components/atoms/Input.vue'
import { log } from '@/log'
import { ApiCoupon } from '@/models/api/coupon'
import { parseToCouponCode } from '@/models/api/coupon/coupon-code/coupon-code'
import { CouponCodeFactory } from '@/models/api/coupon/coupon-code/coupon-code-factory'
import { ApiClient } from '@/services/api/client'
import { fromNullable } from 'fp-ts/lib/Option'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

@Component({
  components: {
    SpaInput,
  },
})
/**
 * コード入力式のクーポンに対して、コード入力・クーポンの適用・クーポンの適用解除を行う。
 */
export default class InputCouponCode extends Vue {
  @Prop({ required: true })
  readonly applied: ApiCoupon | null

  @Prop({ required: true })
  readonly inputCode: string

  invalidCode = false
  isFetching: boolean = false

  created() {
    if (this.applied) {
      // 画面遷移後も入力状態を維持するため、描画時点でクーポンコード適用済みの場合は
      // 適用されているクーポンコードのコードでフォーム初期化
      // ref: https://github.com/my-color/front/pull/6390
      parseToCouponCode(this.applied).fold(
        (e) => { log.info(e.message) },
        (code) => { this.input(code.couponCode) }
      )
    }
  }

  get hasNoCode(): boolean {
    return this.inputCode.length === 0
  }

  /**
   * @return 適用中のクーポンがクーポンコードである場合にtrueを、未適用 or クーポンコード以外が適用中の場合はfalseを返す
   */
  get couponCodeApplied(): boolean {
    return fromNullable(this.applied).fold(false, c => c.hasCouponCode)
  }

  get couponTitle(): string {
    return this.applied ? this.applied.title : ''
  }

  async onTryApply() {
    try {
      this.isFetching = true
      this.invalidCode = false

      const response = await ApiClient.get(`/api/user/coupon/coupon_code/${this.inputCode}`)
        .query({ only_usable: true })
      const coupon = new CouponCodeFactory().create(response.body.data)

      this.apply(coupon)
    } catch (e) {
      log.error(e)

      // 無効なクーポンコードが入力された.
      this.reset()
      this.invalidCode = true
    } finally {
      this.isFetching = false
    }
  }

  handleInput(e: { target: HTMLInputElement }) {
    this.input(e.target.value)
  }

  @Emit()
  input(code: string) {
    return code
  }

  @Emit()
  apply(coupon: ApiCoupon) {
    return coupon
  }

  @Emit()
  unapply() {
    this.invalidCode = false
    this.reset()

    return this.applied
  }

  private reset(): void {
    this.input('')
  }
}
